import React from "react";
import { MapPin, Thermometer, Gauge, Clock } from "lucide-react";
import GlassCard from "./GlassCard";
import StatusBadge from "./StatusBadge";
import FuelBar from "./FuelBar";

const stripColors = {
  active: "var(--status-green)",
  idle: "var(--status-amber)",
  maintenance: "var(--slate-500)",
  alert: "var(--status-red)",
};

export default function MachineCard({ m, onClick }) {
  return (
    <GlassCard
      hoverable
      className="relative overflow-hidden cursor-pointer page-enter"
      onClick={() => onClick && onClick(m)}
      data-testid={`machine-card-${m.machine_id}`}
    >
      <div
        className="absolute left-0 top-3 bottom-3 w-[3px] rounded-full"
        style={{ background: stripColors[m.status] || "var(--slate-500)" }}
      />
      <div className="p-5 pl-6">
        <div className="flex items-start justify-between mb-3">
          <div>
            <div className="font-body font-semibold text-[15px]" style={{ color: "var(--slate-900)" }}>
              {m.machine_id}
            </div>
            <div className="text-[11px] mt-0.5" style={{ color: "var(--slate-500)" }}>
              {m.model}
            </div>
          </div>
          <StatusBadge status={m.status} />
        </div>

        <div className="grid grid-cols-2 gap-3 mb-4">
          <Metric icon={<Gauge size={11} />} label="Util" value={`${m.utilization_pct ?? 0}%`} />
          <Metric icon={<Thermometer size={11} />} label="Temp" value={`${m.temp_c ?? 0}°C`}
                  warn={m.temp_c >= 95} />
          <Metric icon={<Clock size={11} />} label="HMR today" value={`${m.today_hmr ?? 0}h`} />
          <Metric icon={<Gauge size={11} />} label="Total HMR" value={`${m.total_hmr}h`} mono />
        </div>

        <div className="mb-3">
          <div className="flex items-center justify-between mb-1.5">
            <span className="text-[10px] uppercase tracking-wider" style={{ color: "var(--slate-500)" }}>
              Fuel
            </span>
          </div>
          <FuelBar pct={m.fuel_pct ?? 0} />
        </div>

        <div className="flex items-center gap-1.5 text-[11px]" style={{ color: "var(--slate-500)" }}>
          <MapPin size={11} />
          <span>{m.city}</span>
          <span style={{ color: "var(--slate-300)" }}>·</span>
          <span className="font-mono">{m.serial_number}</span>
        </div>
      </div>
    </GlassCard>
  );
}

function Metric({ icon, label, value, warn = false, mono = false }) {
  return (
    <div>
      <div className="flex items-center gap-1 text-[10px] uppercase tracking-wider mb-0.5"
           style={{ color: "var(--slate-500)" }}>
        {icon} <span>{label}</span>
      </div>
      <div
        className={mono ? "font-mono text-[13px]" : "font-body text-[14px] font-medium"}
        style={{ color: warn ? "var(--status-red)" : "var(--slate-900)" }}
      >
        {value}
      </div>
    </div>
  );
}
